import React, { useState, useEffect, useContext } from 'react'

import ArticleLink from '../components/ArticleLink'
import FavoriteBtn from '../components/FavoriteBtn'
import { useParams } from 'react-router-dom'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Nav from 'react-bootstrap/Nav'
import { LinkContainer } from 'react-router-bootstrap'

import '../App.css';
import { FirebaseContext } from '../firebase'

function Sequence(props) {
    const [articles, setArticles] = useState([])
    const [isEmpty, setIsEmpty] = useState(false)
    const [activeArticle, setActiveArticle] = useState("")
    const [sequence, setSequence] = useState("")
    const { sequenceId } = useParams()
    const { fire } = useContext(FirebaseContext)
    const [showSidebar, setShowSidebar] = useState(true)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        setIsLoading(true)
        getSequence()
    }, [])

    useEffect(() => {
        getArticles()
    }, [sequence])

    useEffect(() => {
        if (!isLoading && !isEmpty) {     
            setActiveArticle(articles[0])
        }
    }, [articles])

    function getSequence() {
        fire.firestore().collection('sequences').doc(sequenceId)
            .onSnapshot((doc) => {
                if (doc.exists) {
                    setSequence({
                        id: doc.id,
                        ...doc.data()
                    })
                } else {
                    console.log("Couldn't find Sequence by ID")
                }
            })
    }

    function getArticles() {
        fire.firestore().collection('articles').where('sequence', "==", sequenceId).get()
            .then(s => handleSnapshot(s))
            .then(() => setIsLoading(false))
    }

    function handleSnapshot(snapshot) {
        const parsed = snapshot.docs.map(doc => {
            return {
                id: doc.id,
                ...doc.data()
            }
        })
        parsed.length === 0 ? setIsEmpty(true) : setIsEmpty(false)
        const sortingArray = sequence.articles
        if (sortingArray) {
            setArticles(parsed.sort((a, b) => {
                return sortingArray.indexOf(a.id) - sortingArray.indexOf(b.id)
            }))
        }
    }

    const {user} = useContext(FirebaseContext)

    const isOwner = (user && sequence.createdBy === user.uid)

    const articleComponents = articles.map(article => {
        return (
            <ArticleLink
                article={article}
                sequence={sequence}
                // setActiveArticle={props.setActiveArticle}
                key={article.id}
                // activeArticle={props.activeArticle}
                // setShowSidebar={props.setShowSidebar}
                 />
        )
    })

    return (
        <React.Fragment>
            {!isLoading && isEmpty && <Alert className="mb-0" variant="warning">Looks like this sequence is empty right now...</Alert>}
            <div className="wrapper">
                <nav className={`sidebar`}>
                    <div className="sidebar-header position-relative" style={{backgroundImage: `url(${sequence.img})`}}>
                        <h3>{sequence.name ? sequence.name : null}</h3>
                        <div className="bottom-right" style={{bottom: 4, right: 4}}>
                            <FavoriteBtn sequence={sequence} size="sm"/>
                            {isOwner && (
                                <LinkContainer to={`/edit/${sequence.id}`} className="ml-1">                   
                                    <Button size="sm" variant="dark">Edit</Button>
                                </LinkContainer>
                            )}
                        </div>
                    </div>
                    <Nav className="flex-column" id="sequenceMenu">
                        {articleComponents}
                    </Nav>
                </nav >
            </div>
        </React.Fragment>
    )
}


export default Sequence